import axios from 'axios';
import moment from 'moment';


//import Point from "@arcgis/core/geometry/Point";
//import * as projection from "@arcgis/core/geometry/projection";

//import Map from "@arcgis/core/Map";
//import Map from "https://js.arcgis.com/4.25/@arcgis/core/Map.js";

//import Map from "arcgis-js-api/Map";

//Arcgis javascript api
//https://medium.com/@bachhm.dev/arcgis-with-vue-b3a077492bd3
// import { loadScript } from 'esri-loader';
//
// // preload the ArcGIS API
// const options = {
//   url: 'https://js.arcgis.com/3.23/',
// };
// loadScript(options)
//
// import {
//   loadModules
// } from 'esri-loader';


class MitSpacesUploadService {
  constructor() {
  }
  uploadJSON(data) {
    return new Promise ((resolve, reject) => {
      axios.post('/api/v2/admin/spaces/', data)
        .then((response) => {
            return resolve(response.data);
        })
        .catch((error) => {
          console.log('ERROR:', error);
          return reject(error);
        });

    });
  }


}

export default MitSpacesUploadService;
